import { Stack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import React from 'react';

export const requestModalFieldShellProps = {
  bgColor: 'backgroundshade' as const,
  borderRadius: BoxBorder.thick,
  w: 'full' as const,
};

export const requestModalFieldPadding = 'stack.nano' as const;

export const requestModalInputFontSize = Typography['fontsize.md'];

export const requestModalSelectTriggerProps = {
  bg: 'transparent',
  backgroundColor: 'transparent',
  padding: requestModalFieldPadding,
} as const;

export const requestModalSelectTriggerTextProps = {
  fontWeight: '400' as const,
  variant: 'regular' as const,
};

export const requestModalDatePickerInputProps = {
  hasShadow: false,
  backgroundColor: 'transparent',
  bg: 'transparent',
  fontSize: requestModalInputFontSize,
} as const;

type RequestModalFieldShellProps = {
  children: React.ReactNode;
  flex?: number;
};

export const RequestModalFieldShell: React.FC<RequestModalFieldShellProps> = ({
  children,
  flex,
}) => (
  <Stack {...requestModalFieldShellProps} flex={flex}>
    {children}
  </Stack>
);
